import React from 'react';
import { TextField, Grid, Avatar, MenuItem, Select, Fab, Switch, } from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'
import Ws from '../providers/Ws';

export default class UsersListDrepturi extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            strSearchString: '',
            elementeAfisate: []

        }
    }



    componentDidMount() {
        this.setState({ elementeAfisate: this.props.elemente || [] })
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            elementeAfisate: nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx) => {

        if (tx !== null) {

            return tx.substring(0, 1).toUpperCase()
        }
    }

    filterFunc = (ev) => {

        this.setState({ strSearchString: ev.target.value })
        let e = [...this.props.elemente]

        e = e.filter(x => {

            if ((x[this.props.onlyColumns.nume] || '').toLowerCase().trim().includes(ev.target.value.toLowerCase()))
                return true

            if ((x[this.props.onlyColumns.description] || '').toLowerCase().trim().includes(ev.target.value.toLowerCase()))
                return true

            return false

        })

        this.setState({ elementeAfisate: e })
    }

    render() {
        return (
            <div className='pm-users-list-container'>


                <TextField className='inputFocus' label={this.props.dict.comune.search} onChange={this.filterFunc} value={this.state.strSearchString} />
                <ul style={{ cursor: 'pointer', position: 'relative' }} className='pm-list-container'>
                    <li className='pm-list-item-user' >

                        <Grid container className='pm-list-container-avatar-head' >

                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar-head'>

                                <span className='pm-list-item-span-head'>Avatar</span>

                            </Grid>

                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar-head'>
                                <span className='pm-list-item-span-head'>{this.props.dict.settings.nume}</span>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar-head'>
                                <span className='pm-list-item-span-head'>{this.props.dict.settings.doarCitire}</span>
                            </Grid>

                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar-head'>
                                <span className='pm-list-item-span-head'>{this.props.dict.settings.drepturiExtinse}</span>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar-head'>
                                <span className='pm-list-item-span-head'>{this.props.dict.settings.responsabil}</span>
                            </Grid>


                        </Grid>

                    </li>

                    {
                        this.state.elementeAfisate.map((e, idx) => {
                            return (
                                <li className='pm-list-item-user' key={idx}  >

                                    <Grid container className='pm-list-container-avatar' style={{position:'relative'}}>

                                        <Grid onClick={() => { this.props.onElClick(e) }} style={{ position: 'relative' }} item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar'>
                                            <div className='pm-list-borderleft'></div>

                                            <div style={{ width: 'fit-content', height: '100%', position: 'relative', cursor: 'pointer', marginLeft: 10 }}>

                                                {
                                                    e[this.props.onlyColumns.poza] &&
                                                    <div
                                                        className='pm-angajati-picture'
                                                        style={{ width:45, height:45, backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + e[this.props.onlyColumns.poza]}')` }}>

                                                    </div>
                                                }
                                                {!e[this.props.onlyColumns.poza] &&
                                                   <Avatar style={{ marginTop: 5 }} className='pm-avatar'> {this.getLitereAvatar(e[this.props.onlyColumns.nume] + ' ')} </Avatar>
                                                }


                                            </div>
                                            

                                        </Grid>

                                        <Grid onClick={() => { this.props.onElClick(e) }} item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar'>
                                            <span className='pm-list-item-span'>{e[this.props.onlyColumns.nume]}</span>
                                        </Grid>

                                        <Grid item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar'>
                                            <Switch
                                                className={e[this.props.onlyColumns.doar_citire] !== 1 ? '' : "pm-switch"}
                                                checked={e[this.props.onlyColumns.doar_citire] !== 1 ? false : true}
                                                onChange={() => { this.props.handleCitire(e) }}
                                                value='companie'
                                            />
                                        </Grid>
                                        <Grid style={{ borderRight: 'none' }} item xs={2} sm={2} md={2} lg={2} xl={2} className='pm-list-item-avatar'>
                                            <Switch
                                                className={e[this.props.onlyColumns.drepturi_extinse] !== 1 ? '' : "pm-switch"}
                                                checked={e[this.props.onlyColumns.drepturi_extinse] !== 1 ? false : true}
                                                onChange={() => { this.props.handleExtins(e) }}
                                                value='companie'
                                            />
                                        </Grid>

                                        <Grid style={{ borderRight: 'none' }} item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-item-avatar'>
                                        <select style={{backgroundColor:'transparent',
                                                        width:'100%',
                                                    textAlign:'center',
                                                fontSize:14,
                                            color:e[this.props.onlyColumns.color_responsabil]}}  
                                                className='pm-task-time-input'
                                                value={e[this.props.onlyColumns.nivel_responsabil]}  
                                                onChange={(ev)=>{this.props.levelChange(e,ev)}} 
                                                onBlur={()=>{this.props.updateLevel(e)}}>
                                                {this.props.nivelResponsabilitate.map((n,idx)=>{
                                                    return(
                                                        <option key={idx} value={n.id}>{n.n}</option>
                                                    )
                                                })}

                                        </select>
                                       
                                

                                        </Grid>

                                    <div onClick={()=>{this.props.deleteUser(e)}} style={{position:'absolute', right:-27, top: 10, display:this.props.displayDelete ? 'block' : 'none'}}>
                                        <i className='material-icons' style={{fontSize:27, color:'red'}}>delete</i>
                                    </div>

                                    </Grid>

                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class


UsersListDrepturi.propTypes = {
    elemente: PropTypes.array,
    onlyColumns: PropTypes.object,
    dict: PropTypes.object,
    onElClick: PropTypes.func

}